<template>
  <div id="scenarios" class="scenarios">
    <div class="row mb-3">
      <div class="col-12 col-sm-8 d-flex align-items-center">
        <div class="input-group d-flex align-items-center">
          <input
            type="text"
            class="form-control"
            :placeholder="
              selectedPatientAge == -1 && selectedPatientCondition == -1 && scenarioTags.length == 0
                ? 'Search all scenarios'
                : 'Search within selected scenario parameters'
            "
            aria-label="Search for"
            aria-describedby="basic-addon2"
            id="scenarioSeachTerm"
          />
          <div class="input-group-append">
            <button
              id="scenarioSearchButton"
              @click="updateSearchTerm"
              class="d-flex align-items-center btn btn-primary"
              type="button"
            >
              <i class="material-icons p-0" style="margin-right:7px">search</i>Search
            </button>
          </div>
        </div>
      </div>
      <div class="col-4 ml-auto d-none d-sm-flex pr-4 align-items-center justify-content-end ">
        <div :class="[isTutorial ? 'no-overlay no-click' : '']" class="position-relative">
          <router-link
            to="/scenarios/upload"
            class="upload-button btn btn-success d-inline-block mr-2"
          >
            <div style="display:flex; align-items:center">
              <i class="material-icons p-0" style="margin-right:7px">cloud_upload</i>
              <span class="d-none d-md-block">Upload Scenario</span>
            </div>
          </router-link>

          <div v-if="isTutorial" class="tutorial--arrow-top upload-tutorial">
            A created scenario can be uploaded here and can be published for other users.
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 col-lg-3 col-xl-3 filters-section">
        <div class="d-flex justify-content-start align-items-center">
          <i class="filter-icon material-icons -title mr-2 mt-1">filter_list</i>
          <h5 class="mt-4 mb-3">Filter Scenarios</h5>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-12 mb-lg-3">
            <em class="filter-title">By Patient Age</em>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <ul class="list-group flex-row flex-md-column">
              <li
                @click="selectPatientAge(-1)"
                :class="{
                  active: selectedPatientAge === -1,
                  'list-group-item': true
                }"
              >All</li>
              <li
                @click="selectPatientAge(2)"
                :class="{
                  active: selectedPatientAge === 2,
                  'list-group-item': true
                }"
              >Adult</li>
              <li
                @click="selectPatientAge(1)"
                :class="{
                  active: selectedPatientAge === 1,
                  'list-group-item': true
                }"
              >Paediatric</li>
              <li
                @click="selectPatientAge(0)"
                :class="{
                  active: selectedPatientAge === 0,
                  'list-group-item': true
                }"
              >
                <a>Neonate</a>
              </li>
            </ul>
          </div>
        </div>
        <!-- row -->

        <div class="row">
          <div class="col-sm-4 col-md-12 mb-lg-3">
            <em class="filter-title">By Patient Condition</em>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <ul class="list-group flex-row flex-md-column">
              <li
                @click="selectPatientCondition(-1)"
                :class="{
                    active: selectedPatientCondition === -1,
                    'list-group-item': true
                  }"
              >All</li>
              <li
                @click="selectPatientCondition(0)"
                :class="{
                    active: selectedPatientCondition === 0,
                    'list-group-item': true
                  }"
              >Stable</li>
              <li
                @click="selectPatientCondition(1)"
                :class="{
                    active: selectedPatientCondition === 1,
                    'list-group-item': true
                  }"
              >Deteriorating</li>
              <li
                @click="selectPatientCondition(2)"
                :class="{
                    active: selectedPatientCondition === 2,
                    'list-group-item': true
                  }"
              >Cardiac Arrest</li>
            </ul>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-12 mb-lg-3 d-flex flex-row">
            <em class="filter-title">By Tag Name</em>
          </div>
        </div>

        <div class="row">
          <div class="col-12 mb-3">
            <TagSelector @tag-selection-updated="tagsUpdated" :availableTags="getScenarioTags"></TagSelector>
          </div>
        </div>
      </div>
      <!-- end of side -->

      <div class="position-relative"></div>

      <div
        v-if="isLoading"
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center small-full"
      >
        <PleaseWait></PleaseWait>
      </div>

      <div
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center small-full"
        :class="[isTutorial ? 'no-overlay-under no-click scenarios-tutorial-container' : '']"
        v-if="scenariosCount == 0 && !isLoading"
      >
        <NoResults></NoResults>
      </div>

      <div
        v-if="scenariosCount > 0  && !isLoading"
        class="col-sm col-md-9 col-lg-9 scenario-scroll-page position-relative"
        :class="[isTutorial ? 'no-overlay-under no-click scenarios-tutorial-container' : '']"
      >
        <div v-if="isTutorial" class="tutorial--arrow-bottom scenario-tutorial">
          These are the published scenarios from other users, which can be downloaded.
        </div>

        <div class="row d-flex justify-content-end mr-4">
          <div v-if="scenariosCount > 0 && !isLoading" class="results-count">
            <b class="deep">({{ scenariosCount }})</b>
            Scenario{{ scenariosCount != 1 ? 's' : '' }} available
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div
            v-if="scenariosCount > 0 "
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
        <div class="placeholder">
          <Scenario
            v-cloak
            v-bind:key="scenario.id"
            v-for="scenario in scenarioObjects"
            :uuidId="scenario.uuid_id"
            :userId="scenario.contributed_by.id"
            :name="scenario.name"
            :description="scenario.description"
            :file-size="scenario.file_size"
            :language="scenario.unicode_language_identifier"
            :deviceId="scenario.device_id"
            :numEvents="scenario.num_events"
            :numChecklistItems="scenario.num_checklist_items"
            :hasMedia="scenario.has_video"
            :hasImages="scenario.has_images"
            :hasSounds="scenario.has_sounds"
            :hasLabs="scenario.has_labs"
            :objectUrl="scenario.object_url"
            :durationInSeconds="scenario.duration_in_seconds"
            :numDownloads="scenario.num_downloads"
            :contributedBy="scenario.contributed_by.is_public ? scenario.contributed_by.publicUsername : 'Anonymous User'"
            :userUuId="scenario.contributed_by.uuid"
            :isFavouritedByUser="scenario.is_favourited_by_current_user"
            :numberFavourites="scenario.number_favourites"
            :tags="scenario.tags"
            :patientAge="scenario.patient_age"
            :patientCondition="scenario.patient_condition"
            :currentlySelectedTags="scenarioTags"
          ></Scenario>
        </div>
        <div class="row d-flex justify-content-center">
          <div
            v-if="scenariosCount > 0 "
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Scenario from "../components/Scenario";
import scenService from "../services/scenarios.service";
import TagSelector from "../components/TagSelector";
import Paginate from "../components/Paginate";
import scenariosService from "../services/scenarios.service";
import LoadingSpinner from "../components/LoadingSpinner";
import NoResults from "../components/NoResults";
import PleaseWait from "../components/PleaseWait";

import ScenarioObject from "../objects/ScenarioObject";
import UserObject from "../objects/UserObject";
import TagObject from "../objects/TagObject";

export default {
  name: "Scenarios",
  deviceThumb: "",
  components: {
    TagSelector,
    Scenario,
    Paginate,
    LoadingSpinner,
    PleaseWait,
    NoResults
  },
  data: function() {
    return {
      isLoading: true,
      NUMBER_TO_GET: 5,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      scenarios: [],
      scenarioTags: [],
      scenariosCount: 0,
      selectedPatientAge: -1,
      selectedPatientCondition: -1,
      searchTerm: -1,
      pageNum: 0,
      scenarioObjects: []
    };
  },
  computed: {
    isTutorial() {
      return this.$store.getters.getShowTutorial;
    }
  },
  props: {},
  methods: {
    getScenarios(startAt) {
      this.isLoading = true;
      if (!this.searchTerm) {
        this.searchTerm = -1;
      }

      scenService
        .scenarios(
          startAt,
          this.NUMBER_TO_GET,
          this.selectedPatientAge,
          this.selectedPatientCondition,
          this.searchTerm,
          this.scenarioTags
        )
        .then(data => {
          this.scenariosCount = data.total;
          this.scenarioObjects = [];
          for (let scenario in data.scenarios) {
            this.scenarioObjects.push(
              new ScenarioObject(data.scenarios[scenario])
            );
          }
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.isLoading = false;
        });
    },

    clickCallback: function(pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.scenarioObjects = [];
      this.getScenarios(this.NUMBER_TO_GET * pageNum);
    },

    getScenarioTags() {
      return scenService.scenarioTags();
    },

    selectPatientAge(age) {
      this.isLoading = true;
      this.selectedPatientAge = age;
      this.getScenarios();
    },

    selectPatientCondition(condition) {
      this.isLoading = true;
      this.selectedPatientCondition = condition;
      this.getScenarios();
    },

    tagsUpdated(tags) {
      this.isLoading = true;
      this.scenarioTags = tags;
      this.getScenarios();
    },

    updateFavouriteScenariosList() {
      this.$parent.updateFavouriteScenariosList();
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.scenariosCount / this.NUMBER_TO_GET);
    },

    updateSearchTerm() {
      this.searchTerm = document.getElementById("scenarioSeachTerm").value;
      this.searchTerm = this.searchTerm
        .toLowerCase()
        .replace(/[^a-zA-Z0-9-_' ']/g, "");
      this.searchTerm = this.searchTerm.split(/[ ,]+/).join(",");
      this.getScenarios();
    }
  },

  beforeMount() {
    this.isLoading = true;
  },

  mounted() {
    this.isLoading = true;
    this.getScenarios(0);
    var input = document.getElementById("scenarioSeachTerm");
    input.addEventListener("keyup", function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("scenarioSearchButton").click();
      }
    });
  }
};
</script>

<style scoped>
.placeholder {
  min-height: 900px;
  z-index: 9;
  margin-bottom: 30px;
}

.scenario {
  min-height: 450px;
  margin-bottom: 30px;
}
.scenario {
  overflow: hidden;
}
.search-input {
  width: 100%;
  border: 1px solid black;
}
.scenario {
  /* padding: 7px; */
  margin-bottom: 30px;
  overflow: hidden;
}

.list-group-item {
  cursor: pointer;
}

ul.list-group li:not(:first-child):not(:last-child) {
  border-radius: 0px;
}

ul.list-group li:first-child {
  border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

ul.list-group li:last-child {
  border-top-left-radius: 0px;
  border-top-left-radius: 0px;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .list-group-item {
    flex-grow: 1;
    border-radius: 5px;
    margin: 2px;
    text-align: center;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sm-horizontal-scroll {
    max-width: 100vw;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.number-indicators {
  text-transform: capitalize;
}

.number-indicators b {
  color: #CB2E37;
}

.results-count {
  color: #6c757d;
  font-size: 14px;
}

.deep {
  color: #CB2E37;
}

@media (min-width: 992px) {
  .scenario-scroll-page {
  }
}

.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #CB2E37;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}

[v-cloak] {
  display: none !important;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@media (max-width: 575.98px) {
  .filters-section .list-group {
    flex-wrap: wrap;
    justify-content: center;
  }
  .filters-section .list-group .list-group-item {
    min-width: 40%;
    max-width: 48%;
    border-radius: 0px !important;
  }
  .small-full {
    width: 100% !important;
  }
  .small-full div:first-child {
    text-align: center;
  }
  .upload-button {
    display: none;
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
    .pagination-wrapper {
      margin: 0px !important;
      padding: 0px !important;
      display: flex;
    }
    .pagination-wrapper ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
em.filter-title {
  color: #6c757d;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}
.filter-icon {
  font-size: 20px;
  color: #6c757d;
}

.upload-button {
  min-width: 176px;
  text-align: center;
}

.upload-tutorial {
  top: 45px;
  left: 0;
  right: 0;
}

.scenario-tutorial {
  top: -55px;
  left: 0;
  width: 350px;
}

.scenarios-tutorial-container {
  border: 5px solid #cb2e37;
}
</style>
